import { render, staticRenderFns } from "./message_list_pc.vue?vue&type=template&id=34893080&scoped=true&"
import script from "./message_list_pc.vue?vue&type=script&lang=js&"
export * from "./message_list_pc.vue?vue&type=script&lang=js&"
import style0 from "./message_list_pc.vue?vue&type=style&index=0&id=34893080&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34893080",
  null
  
)

export default component.exports